import { PropertyObjectType } from '@/caregiverSpace/shared/model';

export const mergeProperties = (
    existingProperties: PropertyObjectType[],
    ...newFields: (PropertyObjectType | null)[]
) => {
    const filteredFields = newFields.filter((field) => !!field);
    return [...existingProperties, ...filteredFields];
};
